


































































import { Route } from 'vue-router'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import InviteWorkerModal, {
  Props as ModalProps
} from '@/components/manageTeam/InviteWorkerModal.vue'
import { User, Patient } from '../types/user'

@Component({
  components: {
    ControlTable: () => import('@/components/ControlTable.vue'),
    UserIcon: () => import('@/components/common/UserIcon.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    InviteWorkerModal: InviteWorkerModal
  }
})
export default class ManageTeam extends Vue {
  @Prop(Number) readonly page!: number | undefined

  $store!: ExStore

  pending = true

  modalShow = false
  modalProps: ModalProps = {
    patient: undefined
  }

  get patientIds() {
    return this.patients.map(p => p.id)
  }

  get patients() {
    return this.$store.getters['team/patients']
  }

  getWorkers(ids: number[]) {
    return this.$store.getters['worker/workersById'](ids || [])
  }

  getFullName(user: User): string {
    return user.lastName + user.firstName
  }

  handleClickInviteButton(patient: Patient) {
    this.modalProps.patient = patient
    this.modalShow = !this.modalShow
  }

  loadPatients(page: number) {
    this.pending = true

    return this.$store.dispatch('team/updatePatients').then(() => {
      this.pending = false
      const patientIds = this.patientIds
      this.$store.dispatch('worker/updateList', { patientIds })
    })
  }

  handleWorkerAdded() {
    const page = Number(this.$route.query.page || 1)
    this.loadPatients(page)
  }

  created() {
    const page = Number(this.$route.query.page || 1)
    this.$store.commit('patient/clear')
    this.loadPatients(page)
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    const page = Number(to.query.page || 1)
    this.loadPatients(page)
    next()
  }
}
